(() => {
  'use strict';
  const config = document.getElementById('easy-order-convenience-copy');
  if (!config || window.easyOrderConvenienceMounted) return;
  window.easyOrderConvenienceMounted = true;
  const copy = JSON.parse(config.textContent);
  const main = document.getElementById('MainContent');
  const root = () => main?.querySelector('.easy-area-calculator');
  const shown = node => !!(node && !node.hidden && node.getClientRects().length);
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const label = node => {
    if (node.getAttribute('aria-label')) return node.getAttribute('aria-label');
    const source = node.labels?.[0] || node.closest('fieldset')?.querySelector('legend');
    if (!source) return '';
    const clean = source.cloneNode(true);
    clean.querySelectorAll('input, select, textarea, button').forEach(child => child.remove());
    return clean.textContent.trim();
  };
  const fieldValue = node => node.tagName === 'SELECT' ? node.selectedOptions[0]?.textContent.trim() : node.value;
  const numberFrom = text => Number(String(text).replace(/[^\d.-]/g, ''));
  const normalize = text => String(text || '').toLowerCase().replace(/[\s"“”×x]/g, '').replace(/英寸|inches|inch|\bin\b/g, '');
  let frame = 0;
  let restored = false;
  let approvedButton = null;
  let dialog = null;
  const sync = () => {
    frame = 0;
    const calculator = root();
    if (calculator) {
      const fields = ['width', 'height'].map(name => calculator.querySelector(`[data-easy-${name}]`));
      const info = calculator.closest('product-info') || calculator;
      const shipping = info.querySelector('[data-easy-delivery]:checked')?.value === 'shipping';
      const addressIncomplete = shipping && ['address1','city','state','zip'].some(key => !info.querySelector(`[data-easy-${key}]`)?.value.trim());
      const nativeCheckout = !!info.querySelector('.easy-native-checkout-order');
      const designAmount = calculator.querySelector('[data-easy-design-custom-amount], #easy-design-custom-amount');
      const designIncomplete = designAmount && !(Number(designAmount.value)>0 || Number(calculator.querySelector('[data-easy-design-hours]')?.value)>0);
      const dimensionsMissing = fields.some(field => field && !(Number(field.value) > 0));
      const pending = dimensionsMissing || nativeCheckout || designIncomplete || ['pending','error'].includes(calculator.dataset.easyQuoteState);
      const message = dimensionsMissing ? '输入尺寸后显示价格' : nativeCheckout ? '选择配送后在购物车核对应付总价' : designIncomplete ? '请填写设计金额或选择设计服务' : calculator.dataset.easyQuoteState === 'error' ? (calculator.dataset.easyQuoteError || '计算价格失败，请查看下方错误提示并重新计算') : calculator.dataset.easyQuoteState === 'pending' ? '正在核对应付总价…' : copy.empty;
      const shippingFields = info.querySelector('[data-easy-shipping-fields]');
      if (shippingFields) {
        let reminder = shippingFields.querySelector('[data-easy-address-reminder]');
        if (!reminder) {
          reminder = document.createElement('p');
          reminder.dataset.easyAddressReminder = '';
          reminder.className = 'easy-area-calculator__hint easy-area-calculator__full';
          reminder.setAttribute('role', 'status');
          shippingFields.append(reminder);
        }
        setText(reminder, copy.address_reminder);
        if (reminder.hidden !== !addressIncomplete) reminder.hidden = !addressIncomplete;
      }
      let titleTotal = info.querySelector('[data-easy-title-total]');
      if (titleTotal && !titleTotal.dataset.easyPayableMounted) {
        const replacement = titleTotal.cloneNode(true);
        replacement.dataset.easyPayableMounted = 'true';
        replacement.hidden = false;
        titleTotal.replaceWith(replacement);
        titleTotal = replacement;
      }
      const quoted = info.querySelector('[data-easy-total]')?.textContent.trim();
      if (titleTotal) {
        setText(titleTotal.querySelector('span'), '应付总价');
        if (quoted && /\d/.test(quoted)) setText(titleTotal.querySelector('strong'), quoted);
      }
      document.body.toggleAttribute('data-easy-quote-pending', pending);
      document.querySelectorAll('[data-easy-total], [data-easy-title-total] strong').forEach(node => {
        if (pending && node.getAttribute('data-easy-quote-empty') !== message) {
          node.setAttribute('data-easy-quote-empty', message);
          node.setAttribute('aria-label', message);
        }
        if (!pending && node.hasAttribute('data-easy-quote-empty')) {
          node.removeAttribute('data-easy-quote-empty');
          node.removeAttribute('aria-label');
        }
      });
      fields.forEach(field => {
        if (field?.placeholder && !field.dataset.easyExample) {
          field.placeholder = `${copy.example}${field.placeholder}`;
          field.dataset.easyExample = 'true';
        }
      });
      document.querySelectorAll('pickup-availability .pickup-availability-info > .caption, pickup-availability-drawer .pickup-availability-list__item > .pickup-availability-preview').forEach(node => setText(node, copy.pickup));
      restore(calculator);
    }
    const account = document.querySelector('header a.header__icon--account');
    if (account && !document.querySelector('[data-easy-account-entry]')) {
      const link = document.createElement('a');
      link.href = account.href;
      link.className = 'easy-account-entry';
      link.dataset.easyAccountEntry = '';
      link.textContent = copy.account;
      account.insertAdjacentElement('afterend', link);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const collect = calculator => {
    const pairs = [];
    const controls = [...calculator.querySelectorAll('input, select, textarea'), ...document.querySelectorAll('product-info variant-selects input, product-info variant-selects select, product-info variant-radios input')];
    controls.forEach(node => {
      if (['hidden', 'file', 'submit', 'button'].includes(node.type) || node.disabled) return;
      if (['radio', 'checkbox'].includes(node.type) && !node.checked) return;
      if (!shown(node) && !node.closest('[data-easy-more-options-panel]')) return;
      const key = label(node);
      const value = ['radio', 'checkbox'].includes(node.type) ? label(node) : fieldValue(node);
      if (key && value && !pairs.some(pair => pair[0] === key && pair[1] === value)) pairs.push([key, value]);
    });
    calculator.querySelectorAll('[data-easy-variant-field]').forEach(field => {
      const fixed = field.querySelector('.easy-flyer-static, .easy-area-calculator__static-value');
      const key = field.querySelector('.easy-flyer-label, label')?.textContent.trim();
      const value = fixed?.textContent.trim();
      if (key && value && !pairs.some(pair => pair[0] === key && pair[1] === value)) pairs.push([key, value]);
    });
    const sharedUpload = calculator.querySelector('.easy-multi-version-upload');
    const uploads = sharedUpload
      ? [...sharedUpload.querySelectorAll('.easy-upload-four-file')].map(card => {
          const file = card.querySelector('a[href]');
          return file ? [card.dataset.uploadLabel, card.querySelector('strong')?.textContent.trim(), file.textContent.trim()].filter(Boolean).join(' · ') : '';
        }).filter(Boolean)
      : [...calculator.querySelectorAll('[data-easy-upload-status]')].filter(shown).map(node => node.textContent.trim());
    pairs.push([copy.files, uploads.join('\n') || copy.no_file]);
    return pairs;
  };
  const review = (button, calculator) => {
    if (!window.HTMLDialogElement || !dialog?.showModal && typeof HTMLDialogElement.prototype.showModal !== 'function') return false;
    if (dialog) dialog.remove();
    dialog = document.createElement('dialog');
    dialog.className = 'easy-review';
    dialog.setAttribute('aria-labelledby', 'easy-review-title');
    const title = document.createElement('h2'); title.id = 'easy-review-title'; title.textContent = copy.review;
    const hint = document.createElement('p'); hint.textContent = copy.check;
    const product = document.createElement('p'); product.textContent = document.querySelector('h1')?.textContent.trim() || '';
    const dl = document.createElement('dl');
    collect(calculator).forEach(([key, value]) => {
      const row = document.createElement('div'); row.className = 'easy-review__row';
      const dt = document.createElement('dt'); dt.textContent = key;
      const dd = document.createElement('dd'); dd.textContent = value;
      row.append(dt, dd); dl.append(row);
    });
    const total = document.createElement('p'); total.className = 'easy-review__total';
    total.textContent = `${copy.total} ${document.querySelector('[data-easy-total]')?.textContent.trim() || ''}`;
    const actions = document.createElement('div'); actions.className = 'easy-review__actions';
    const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = copy.edit;
    const next = document.createElement('button'); next.type = 'button'; next.textContent = copy.continue; next.dataset.reviewContinue = '';
    edit.addEventListener('click', () => dialog.close());
    next.addEventListener('click', () => {
      dialog.close();
      if (!button.isConnected || button.disabled) return;
      approvedButton = button;
      button.click();
      approvedButton = null;
    });
    dialog.addEventListener('close', () => button.focus());
    actions.append(edit, next); dialog.append(title, product, hint, dl, total, actions); document.body.append(dialog); dialog.showModal(); edit.focus();
    return true;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-easy-pay]');
    if (!button || button.disabled || button === approvedButton) return;
    const calculator = root();
    if (!calculator || document.body.hasAttribute('data-easy-quote-pending')) return;
    if (!event.isTrusted && button.closest('product-info')?.querySelector('.easy-business-add-to-cart:disabled')) return;
    const total = document.querySelector('[data-easy-total]');
    if (!total || !(numberFrom(total.textContent) > 0)) return;
    if (review(button, calculator)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  const aliases = {
    width: ['width', '宽度', '宽度（英寸）'], height: ['height', '高度', '高度（英寸）'], quantity: ['quantity', '数量'],
    size: ['size', '尺寸'], paper: ['paper', '纸张'], color: ['color', '颜色'], orientation: ['orientation', '方向'],
    material: ['material', '材质'], 'print sides': ['print sides', '印刷面数'], 'cutting': ['cutting', '切割方式'],
    'pole pocket': ['pole pocket', '杆袋'], hem: ['hem', '包边'], grommet: ['grommet', '扣眼']
  };
  const canonical = key => Object.keys(aliases).find(name => aliases[name].includes(String(key).toLowerCase().trim())) || String(key).toLowerCase().trim();
  const restore = calculator => {
    if (restored || !new URLSearchParams(location.search).has('reorder')) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem('easy-reorder') || 'null'); } catch (_) { return; }
    const handle = decodeURIComponent(location.pathname.split('/products/')[1]?.split('/')[0] || '');
    if (!saved || saved.handle !== handle || Date.now() - saved.created > 30 * 60 * 1000 || !Array.isArray(saved.attributes)) return;
    if (!calculator.querySelector('[data-easy-pay]')) return;
    restored = true;
    sessionStorage.removeItem('easy-reorder');
    const missed = [];
    saved.attributes.forEach(attribute => {
      const key = canonical(attribute.key);
      if (!Object.hasOwn(aliases, key)) { missed.push(`${attribute.key}: ${attribute.value}`); return; }
      const all = [...calculator.querySelectorAll('input, select'), ...document.querySelectorAll('product-info variant-selects select')];
      const target = ['width', 'height', 'quantity'].includes(key) ? (key === 'quantity' ? calculator.querySelector('[data-easy-banner-job-quantity]') || calculator.querySelector('[data-easy-quantity]') : calculator.querySelector(`[data-easy-${key}]`)) : all.find(node => canonical(label(node)) === key);
      if (!target || target.type === 'radio' || target.type === 'checkbox') { missed.push(`${attribute.key}: ${attribute.value}`); return; }
      let value = String(attribute.value);
      if (target.tagName === 'SELECT') {
        const option = [...target.options].find(item => !item.disabled && normalize(item.textContent) === normalize(value));
        if (!option) { missed.push(`${attribute.key}: ${attribute.value}`); return; }
        value = option.value;
      } else {
        if (!['width', 'height', 'quantity'].includes(key) || target.type !== 'number') return;
        const match = value.match(/^\s*(\d+(?:\.\d+)?)\s*(?:in|inch|inches|英寸|["”])?\s*$/i);
        const number = match && Number(match[1]);
        if (!(number > 0) || target.min && number < Number(target.min) || target.max && number > Number(target.max)) { missed.push(`${attribute.key}: ${attribute.value}`); return; }
        value = String(number);
      }
      target.value = value;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (handle==='poster-stand' && calculator._easyRestorePosterVersions && Array.isArray(saved.jobs) && saved.jobs.length) calculator._easyRestorePosterVersions({mode:saved.jobs.length>1?'different':'same',groups:saved.jobs.map(job=>({quantity:Number(job.quantity)}))});
    const notice = document.createElement('section'); notice.className = 'easy-reorder-notice'; notice.setAttribute('role', 'status');
    const text = document.createElement('p'); text.textContent = copy.restored; notice.append(text);
    const history = document.createElement('p'); history.textContent = saved.attributes.map(attribute=>`${attribute.key}: ${attribute.value}`).join('；'); notice.append(history);
    if (missed.length) { const warning = document.createElement('p'); warning.textContent = `${copy.unmatched} ${missed.join('；')}`; notice.append(warning); }
    calculator.prepend(notice);
  };
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' || (record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('pickup-availability, pickup-availability-drawer, [data-easy-total]') ||
      [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) schedule();
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-easy-quote-state'] });
  document.addEventListener('input', event => {
    if (event.target.matches?.('[data-easy-width], [data-easy-height], [data-easy-address1], [data-easy-city], [data-easy-state], [data-easy-zip], [data-easy-design-custom-amount], #easy-design-custom-amount')) schedule();
  }, true);
  document.addEventListener('change', schedule, true);
  sync();
})();


